// The bare identifier, wrapped in an object: synapse's `DefaultPayload` forbids a bare scalar.
export type DocumentTemplateArchivedPayload = {
	templateId: number;
};

export type DocumentTemplateArchivedAction = {
	type: 'DOCUMENT_TEMPLATE_ARCHIVED';
	payload: DocumentTemplateArchivedPayload;
};

export default (payload: DocumentTemplateArchivedPayload): DocumentTemplateArchivedAction => ({
	type: 'DOCUMENT_TEMPLATE_ARCHIVED',
	payload,
});
